import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileSparkle"><Path d="M12 10H20V21.25C20 21.6642 19.6642 22 19.25 22H8.00684L8.55957 20.5596L11.5 19.4307V16.5693L8.55957 15.4395L7.43066 12.5H4.56934L4.2002 13.4619L4 13.9814V2.75C4 2.33579 4.33579 2 4.75 2H12V10Z" fill="currentColor"/><Path d="M19.5605 8.5H13.5V2.43945L19.5605 8.5Z" fill="currentColor"/><Path d="M6.4 14H5.6L4.6 16.6L2 17.6V18.4L4.6 19.4L5.6 22H6.4L7.4 19.4L10 18.4V17.6L7.4 16.6L6.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileSparkle;
